module.exports = __webpack_public_path__ + "img/electronic_reserved.e9c0da13.svg";